<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-trabajo-adicional'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-trabajo-adicional"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="id"
          :empty-text="$t('No matching records found')"
          show-empty
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(empleado)="data">
            <router-link
              target="_blank"
              :class="[textLink]"
              :to="{
                name: 'rrhh-employees-information',
                params: { id: data.item.id_personal },
              }"
            >
              {{ data.item.empleado | capitalize }} </router-link
            ><br />
            <span style="opacity: 0.7"> {{ data.item.area | capitalize }} </span
            ><br />
            <span style="opacity: 0.7" class="text-primary">
              {{ data.item.numero_documento | capitalize }}
            </span>
          </template>

          <template #cell(estado)="data">
            <b-badge :variant="getStatusVariant(data.item.estado)">
              <span class="text-uppercase">
                {{ data.item.estado }}
              </span>
            </b-badge>
          </template>

          <template #cell(created_at)="data">
            <div class="d-flex justify-content-center flex-column">
              <span style="opacity: 0.8">
                {{ data.item.created_at | myGlobalDay }}
              </span>
            </div>
          </template>

          <template #cell(revisador)="data">
            <div v-if="data.item.revisador" class="d-flex flex-column">
              <span>
                {{ data.item.revisador }}
              </span>
              <span style="opacity: 0.8">
                {{ data.item.updated_at | myGlobalDay }}
              </span>
            </div>
          </template>

          <template #cell(archivo)="data">
            <b-link
              v-if="data.item.archivo"
              :href="data.item.archivo"
              target="_blank"
              class="text-primary"
              ><feather-icon icon="FileIcon" class="text-primary"
            /></b-link>
            <span v-else>-</span>
          </template>

          <template #cell(remunerable)="data">
            <b-badge
              :variant="
                data.item.remunerable ? 'light-success' : 'light-danger'
              "
            >
              <span class="text-uppercase">
                {{ data.item.remunerable ? "SI" : "NO" }}
              </span>
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <b-button
              v-if="data.item.estado === 'pendiente'"
              class="btn-icon ml-1"
              variant="outline-success"
              size="sm"
              @click="openModal(data.item)"
            >
              APROBAR
            </b-button>

            <b-button
              v-if="data.item.estado !== 'pendiente'"
              size="sm"
              variant="outline-primary"
              @click="
                openHistorialTrabajoAdicionalModal(
                  data.item.id_trabajo_adicional
                )
              "
            >
              <feather-icon icon="ListIcon"></feather-icon>
            </b-button>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <TrabajoAdicionalModal
      v-if="showModal"
      :id="id_trabajo_adicional"
      :procesar="true"
      @update="
        (showModal = false), $refs['ref-table-trabajo-adicional'].refresh()
      "
      @close="showModal = false"
    />

    <TrabajoAdicionalHistorialModal
      v-if="showTrabajoAdicionalHistorialModal"
      :id="id_trabajo_adicional"
      @close="
        (showTrabajoAdicionalHistorialModal = false),
          (id_trabajo_adicional = null)
      "
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

/* Data */
import Fields from "@/views/rrhh/views/trabajo-adicional/data/table.field.data.js";
import Filters from "@/views/rrhh/views/trabajo-adicional/data/table.filters.js";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

/* Modals */
import TrabajoAdicionalModal from "@/views/rrhh/views/trabajo-adicional/components/TrabajoAdicionalModal.vue";
import TrabajoAdicionalHistorialModal from "@/views/rrhh/views/trabajo-adicional/components/TrabajoAdicionalHistorialModal.vue";

/* Services */
import TrabajoAdicionalService from "@/views/rrhh/views/trabajo-adicional/services/trabajo.adicional.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";

export default {
  components: {
    FilterSlot,
    TrabajoAdicionalModal,
    TrabajoAdicionalHistorialModal,
  },
  data() {
    return {
      filters: Filters,
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      showModal: false,
      modalData: {},
      id_trabajo_adicional: null,
      showTrabajoAdicionalHistorialModal: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  async created() {
    await Promise.all([this.getAreas()]);
  },
  methods: {
    refreshTable() {
      this.$refs["ref-table-trabajo-adicional"].refresh();
    },
    openModal(data) {
      this.id_trabajo_adicional = data.id_trabajo_adicional;
      this.showModal = true;
    },
    async myProvider(ctx) {
      try {
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
          start_date_from: this.filters[2].model,
          start_date_to: this.filters[3].model,
          area_id: this.filters[4].model,
          start_created_at_from: this.filters[0].model,
          start_created_at_to: this.filters[1].model,
        };
        const { data } = await TrabajoAdicionalService.index(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getAreas() {
      try {
        const { data } = await EmployeeService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.filters[4].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    getStatusVariant(status) {
      switch (status) {
        case "pendiente":
          return "light-warning";
        case "aprobado":
          return "light-success";
        case "anulado":
          return "light-info";
      }
    },
    openHistorialTrabajoAdicionalModal(id) {
      this.showTrabajoAdicionalHistorialModal = true;
      this.id_trabajo_adicional = id;
    },
  },
};
</script>

<style>
.k-datepicker {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}

.k-datepicker span {
  border-width: 0 !important;
  background-color: transparent !important;
}

.k-datepicker:hover {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}

.dark-layout .k-datepicker:hover {
  background-color: transparent !important;
}

.k-state-hover .k-state-focused {
  background-color: transparent !important;
  border-color: transparent !important;
}

.k-widget.form-control .k-input {
  height: 2.5rem !important;
}
</style>